import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QrCode, Eye, RotateCw, Clock } from 'lucide-react';
import { WalletData, DisplayData } from '../../../types/wallet.types';
import { useWindow } from '../../../context/WindowContext';
import { Link } from "react-router-dom"
import { CRYPTO_WALLETS } from '../../../constants/wallets';
import {CryptoWalletType } from '../../../types/assets.types';
import { toast } from 'react-toastify';
// Define props interface for the component
interface WalletItemType {
  id:string;
  userId:string;
  network:string;
  address:string;
  currency:string;
  balance:string;
}
interface WalletDetailsItemProps {
  wallet: WalletItemType;
  // index: number;
  handleShowQRCode: (currency: string, address: string) => void;
  // getWalletDisplayBalance: (wallet: WalletData) => DisplayData;
  // getCurrencyIcon: (currency: string) => React.ReactNode;
  // getCurrencyName: (currency: string) => string;
  // getBlockchainExplorerUrl: (currency: string, address: string) => string;
  // getBlockchainExplorerName: (currency: string) => string;
  formatBalance: (balance: string, currency: string) => string;
}

// Define Link component props
interface LinkProps {
  to: string;
  children: React.ReactNode;
}

const WalletDetailsItem: React.FC<WalletDetailsItemProps> = ({
  wallet,
  // index,
  handleShowQRCode,
  // getWalletDisplayBalance,
  // getCurrencyIcon,
  // getCurrencyName,
  // getBlockchainExplorerUrl,
  // getBlockchainExplorerName,
  formatBalance
}) => {
  const { t } = useTranslation();
  // const displayData = getWalletDisplayBalance(wallet);
  const { windowWidth } = useWindow();
  const [walletDataType, setWalletDataType] = useState<CryptoWalletType>()
  // These components would normally be imported from react-router-dom
  // For this artifact, we'll create a simple Link component
  // const Link: React.FC<LinkProps> = ({ to, children }) => (
  //   <a href={to} style={{ textDecoration: 'none' }} className={`${windowWidth < 426 ? "w-full" : ""}`}>
  //     {children}
  //   </a>
  // );

  // Icons referenced in original code
  const QrCodeIcon = QrCode;
  const EyeIcon = Eye;
  const ExchangeIcon = RotateCw;
  const HistoryIcon = Clock;
  // const Icon = walletDataType.icon()
  // const IconComponent = walletDataType?.icon;
  const filteredCrypto = CRYPTO_WALLETS.filter(crypto =>
    crypto.network.toLowerCase().includes(wallet.network.toLowerCase()) &&
    crypto.currency.toLowerCase().includes(wallet.currency.toLowerCase())
  );
  const getIcon=()=>{
    if (filteredCrypto.length > 0 && filteredCrypto[0]) {
      return filteredCrypto[0].icon;
    }
    // Fallback icon si no se encuentra
    return () => <QrCodeIcon />;
  }
  const icon = getIcon();
  const getBlockchainExplorer = (network: string, address: string, currency: string) => {
    // Handle the network name correctly
    const networkUpper = network.toUpperCase();
    const currencyUpper = currency.toUpperCase();

    switch (networkUpper) {
      case 'BITCOIN':
        return `https://www.blockchain.com/explorer/addresses/btc/${address}`;
      case 'ETHEREUM':
        // For Ethereum network, use Etherscan for ETH and all ERC-20 tokens
        return `https://etherscan.io/address/${address}`;
      case 'BNB':
      case 'BSC':
      case 'BINANCE':
        // For BNB/BSC network, use BscScan for BNB and all BEP-20 tokens
        return `https://bscscan.com/address/${address}`;
      case 'TRON':
        // For TRON network, use TronScan for TRX and all TRC-20 tokens
        return `https://tronscan.org/#/address/${address}`;
      case 'SOLANA':
        // For Solana network, use Solscan for SOL and all SPL tokens
        return `https://solscan.io/account/${address}`;
      default:
        return '';
    }
  };
  const confirmBalance = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (parseFloat(wallet.balance) <= 0) {
      toast.warn("You haven't enough balance to transfer in this wallet!");
      e.preventDefault();
    }
  };
  // useEffect(()=>{
  // const filteredCrypto = CRYPTO_WALLETS.filter(crypto =>
  //     crypto.network.toLowerCase().includes(wallet.network.toLowerCase()) &&
  //     crypto.currency.toLowerCase().includes(wallet.currency.toLowerCase())
  //   );
  //   setWalletDataType(filteredCrypto[0])
  // }, [wallet])
  // useEffect(()=>{
  //   // console.log(typeof(IconComponent))
  // },[walletDataType])
  return (
    <>
      {windowWidth < 426 ? (
        <div className='p-[15px] bg-white rounded-lg shadow-sm flex flex-wrap items-center justify-between'>
          <div className='flex items-center gap-[15px] w-full p-2'>
            <div className='flex items-center gap-2'>
                  {icon()}
              <h3 className='text-[25px] font-bold'>
                   {filteredCrypto[0]?.name || wallet.currency}
              </h3>
            </div>
            <p className='text-[15px] font-bold text-[#B3A369] ml-auto'>
              {formatBalance(wallet.balance, filteredCrypto[0]?.currency || wallet.currency)} {filteredCrypto[0]?.currency || wallet.currency}
            </p>
          </div>
          <div>
            <p className='text-[14px] text-[#666] break-all'>
              {wallet.address}
            </p>
            <a
               href={getBlockchainExplorer(wallet.network, wallet.address, wallet.currency)}
              target="_blank"
              rel="noopener noreferrer"
              className='text-[14px] text-[#003DA5] no-underline'
            >
              {t('wallets.viewOnExplorer')}
            </a>
          </div>
          <div className=''>
            <div className="flex gap-1 mt-3 flex-wrap justify-between ">
              <button
                onClick={() => handleShowQRCode(wallet.currency, wallet.address)}
                className="dashboard-btn dashboard-btn-sm w-full"
              >
                <QrCodeIcon style={{ marginRight: '5px' }} size={16} /> {t('wallets.qrCode')}
              </button>

              <Link to={`/dashboard/wallets/${wallet.currency.toLowerCase()}/${wallet.address}`} className="dashboard-btn dashboard-btn-sm w-full">
                <button className="dashboard-btn dashboard-btn-sm w-full">
                  <EyeIcon style={{ marginRight: '5px' }} size={16} /> {t('common.details')}
                </button>
              </Link>

              <Link to={`/dashboard/transfers?wallet=${wallet.address}&currency=${wallet.currency}&showWarning=true`} className="dashboard-btn dashboard-btn-sm w-full">
                <button className="dashboard-btn dashboard-btn-sm w-full">
                  <ExchangeIcon style={{ marginRight: '5px' }} size={16} /> {t('transfers.title')}
                </button>
              </Link>

              <Link to={`/dashboard/transactions?wallet=${wallet.address}&currency=${wallet.currency}`} className="dashboard-btn dashboard-btn-sm w-full">
                <button className="dashboard-btn dashboard-btn-sm w-full">
                  <HistoryIcon style={{ marginRight: '5px' }} size={16} /> {t('wallets.transactionHistory')}
                </button>
              </Link>
            </div>
          </div>
        </div>
      ) : (

        <div className='p-[20px] bg-white rounded-lg shadow-sm flex flex-wrap items-center justify-between'>
          <div className='flex items-center gap-[15px] w-4/7'>
            <div>
              {icon()}
            </div>
            <div>
              <h3 className='text-[18px] font-bold'>
                {filteredCrypto[0]?.name || wallet.currency}
              </h3>
              <p className='text-[14px] text-[#666] break-all'>
                {wallet.address}
              </p>
              <a
                href={getBlockchainExplorer(wallet.network, wallet.address, wallet.currency)}
                target="_blank"
                rel="noopener noreferrer"
                className='text-[14px] text-[#003DA5] no-underline'
              >
                {t('wallets.viewOnExplorer')}
              </a>
            </div>
          </div>

          <div className='text-right w-3/7'>
            <p className='text-[20px] font-bold text-[#B3A369]'>
               {formatBalance(wallet.balance, filteredCrypto[0]?.currency || wallet.currency)} {filteredCrypto[0]?.currency || wallet.currency}
            </p>

            <div className="flex gap-3 mt-3 flex-wrap justify-end">
              <button
                onClick={() => handleShowQRCode(wallet.currency, wallet.address)}
                className="dashboard-btn dashboard-btn-sm w-32"
              >
                <QrCodeIcon style={{ marginRight: '5px' }} size={16} /> {t('wallets.qrCode')}
              </button>

              <Link to={`/dashboard/wallets/${wallet.currency.toLowerCase()}/${wallet.address}`} className="dashboard-btn dashboard-btn-sm w-32">
             
                  <EyeIcon style={{ marginRight: '5px' }} size={16} /> {t('common.details')}
             
              </Link>

              <Link to={`/dashboard/transfers?wallet=${wallet.address}&currency=${wallet.currency}&showWarning=true`} className="dashboard-btn dashboard-btn-sm w-32" onClick={confirmBalance}>
              
                  <ExchangeIcon style={{ marginRight: '5px' }} size={16} /> {t('transfers.title')}
               
              </Link>

              <Link to={`/dashboard/transactions?wallet=${wallet.address}&currency=${wallet.currency}`} className="dashboard-btn dashboard-btn-sm w-32">
                
                  <HistoryIcon style={{ marginRight: '5px' }} size={16} /> {t('wallets.transactionHistory')}
               
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletDetailsItem;